/* eslint-disable */ 
import React from 'react' ;
import { InputText } from 'primereact/inputtext';


export default function TextInput (props) {

    return <InputText {...props} />
    
}